import { openURL } from 'quasar'

export default {
   name: 'LayoutDefault',
   data() {
      return {
      }
   },
   methods: {
      openURL
   }
}
